import axios from 'axios';
// config
import { BE_URL } from '../config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: BE_URL });

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');

    // Ensure every request includes the latest token (fixes first-load race conditions)
    if (token) {
      // Axios v1 may store headers as a plain object or AxiosHeaders-like object.
      // @ts-ignore
      const existingAuth = config?.headers?.Authorization || config?.headers?.authorization;
      if (!existingAuth) {
        // @ts-ignore
        config.headers = {
          // @ts-ignore
          ...(config.headers || {}),
          Authorization: `Bearer ${token}`,
        };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
